import React from 'react';
import { FadeIn } from '../components/ui/FadeIn';
import { Heart, MessageCircle, PenLine, Sparkles, BookHeart, Users } from 'lucide-react';
const BENEFITS = [{
  icon: Heart,
  text: 'Conectar emocionalmente con tu bebé'
}, {
  icon: MessageCircle,
  text: 'Hablar con él cada semana'
}, {
  icon: PenLine,
  text: 'Registrar tus pensamientos'
}, {
  icon: Sparkles,
  text: 'Capturar tus emociones'
}, {
  icon: BookHeart,
  text: 'Guardar recuerdos irrepetibles'
}, {
  icon: Users,
  text: 'Crear un legado familiar'
}];
export function ProblemSolution() {
  return <section className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-174">
      <FadeIn data-id="element-175">
        <div className="text-center max-w-3xl mx-auto space-y-6 mb-16" data-id="element-176">
          <p className="text-lg text-gray-700 leading-relaxed" data-id="element-177">
            La mayoría de las mujeres creen que el vínculo con su bebé comienza
            cuando lo sostienen por primera vez. Pero el verdadero problema no
            es la falta de amor. No es la falta de tiempo. No es la falta de
            instinto maternal.
          </p>
          <p className="text-lg font-semibold text-brand-burgundy" data-id="element-178">
            El verdadero problema es...
          </p>
        </div>
      </FadeIn>

      <FadeIn delay={0.2} data-id="element-179">
        <div className="bg-white border border-brand-gold/30 rounded-3xl p-8 md:p-12 text-center shadow-sm relative overflow-hidden mb-24" data-id="element-180">
          <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-brand-rose-light via-brand-rose to-brand-burgundy" data-id="element-181"></div>
          <h3 className="text-2xl md:text-3xl font-serif text-brand-burgundy mb-4" data-id="element-182">
            La Brecha de los Recuerdos del Embarazo™
          </h3>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-183">
            Es el fenómeno silencioso donde desaparecen para siempre emociones,
            sueños, promesas y recuerdos porque nunca fueron capturados.
          </p>
        </div>
      </FadeIn>

      <FadeIn delay={0.3} data-id="element-184">
        <div className="text-center mb-12" data-id="element-185">
          <h2 className="text-3xl md:text-4xl font-serif text-brand-burgundy mb-6" data-id="element-186">
            Por eso creamos el Método de las 40 Semanas de Conexión™
          </h2>
          <p className="text-lg text-gray-600" data-id="element-187">
            Un sistema guiado para ayudarte a:
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-188">
          {BENEFITS.map((benefit, idx) => {
          const Icon = benefit.icon;
          return <div key={idx} className="bg-brand-cream-alt border border-brand-gold/20 rounded-2xl p-6 flex flex-col items-center text-center gap-4 hover:shadow-md transition-shadow duration-300" data-id="element-189">
                <div className="w-12 h-12 rounded-full bg-brand-rose-light/30 flex items-center justify-center text-brand-burgundy" data-id="element-190">
                  <Icon className="w-6 h-6" strokeWidth={1.5} data-id="element-191" />
                </div>
                <p className="font-medium text-gray-800" data-id="element-192">{benefit.text}</p>
              </div>;
        })}
        </div>
      </FadeIn>
    </section>;
}